import _ from 'underscore';
import { humanize } from 'underscore.string';

import CargomaticLogoLight from 'img/cargomatic-logo-light.png';
import CargomaticLogoDark from 'img/cargomatic-logo-dark.png';
import SignedUrl from './SignedUrlUtils';

const logos = {
  safeco: 'safeco.png',
};

const getClientName = () => {
  const url = window.location.href;

  return _.find(Object.keys(logos), (customer, index) => {
    return url.includes(customer);
  });
};

export default {
  getClientLogo(light = true) {
    let logo = light ? CargomaticLogoLight : CargomaticLogoDark;
    let client = getClientName();

    if (client) {
      try {
        logo = `${CDN_URL}/assets/${logos[client]}`;
      } catch (e) {
        console.error('whitelabel, failed to get signed URL: ', e);
      }
    }

    return logo;
  },

  getClientName() {
    const client = getClientName();
    return client ? humanize(client) : 'Cargomatic';
  },
};
